import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { BookOpen, Download } from 'lucide-react';
import { mediaVariantUrl } from '../hooks/useMediaRestore.js';
import { collectionFor } from '../collections.js';
import PostcardCard from './PostcardCard.jsx';
import { useCatalogNavigation } from '../hooks/useCatalogNavigation.js';

export function BookCard({ book, index = 0, mediaRevision = 0 }) {
  const navigation = useCatalogNavigation(book.itemType);
  if (book.itemType === 'postcard') return <PostcardCard book={book} index={index} mediaRevision={mediaRevision}/>;
  const coverUrl = mediaVariantUrl(book.coverUrl, 'cover-small', mediaRevision);
  const collection = collectionFor(book);
  const visual = ['postcard', 'exlibris'].includes(book.itemType);
  return <motion.article className={`book-card glass ${visual ? 'visual-card' : ''}`} initial={{ opacity: 0, y: 22 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: Math.min(index * .035, .3) }} whileHover={{ y: -4 }}>
    <Link to={`/carte/${book.id}`} state={navigation.state} className="cover-wrap" aria-label={`Deschide ${book.title}`}>
      <img src={coverUrl} alt={`${collection.singular}: ${book.title}`} loading={index < 4 ? 'eager' : 'lazy'} fetchPriority={index < 2 ? 'high' : 'auto'} decoding="async" />
      <span className="card-open"><BookOpen size={17}/><b>Detalii</b></span>
    </Link>
    <div className="book-card-body">
      <span className="eyebrow">{book.category}</span>
      <h3><Link to={`/carte/${book.id}`} state={navigation.state}>{book.title}</Link></h3>
      <p>{visual ? (book.author.includes('neidentificat') ? (book.identifier || collection.label) : book.author) : book.itemType === 'press' ? (book.collectionMetadata.issue || book.author) : book.author}</p>
      <div className="card-actions">
        <Link to={`/citeste/${book.id}`} state={navigation.state}><BookOpen size={16}/> {collection.action}</Link>
        {book.downloadUrl && <a href={book.downloadUrl} title="Descarcă PDF"><Download size={16}/></a>}
      </div>
    </div>
  </motion.article>;
}

export function BookSkeleton() {
  return <div className="book-card skeleton-card glass" aria-hidden="true"><div className="skeleton cover-skeleton"/><div className="book-card-body"><div className="skeleton line short"/><div className="skeleton line"/><div className="skeleton line medium"/></div></div>;
}
